import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { fields } from "../../common/lib/redux-fields";
import { ValidationError } from "../../common/lib/validation";

import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Label,
  FormFeedback,
  Button
} from "reactstrap";

import { create, get, update } from "../../common/admin/actions";
import { clearError, clearForm } from "../../common/admin/actions";

import ButtonWithLoader from "../../browser/components/Form/ButtonWithLoader";
import Input from "../../browser/components/Form/Input";
import Dropzone from "../../browser/components/Form/Dropzone";

const formFields = ["email", "password", "confirmPassword"];

class Form extends React.Component {
  constructor() {
    super();

    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  componentDidMount() {
    const { params, get, editForm, fields, clearForm } = this.props;

    fields.$reset();
    clearForm();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  async create(e) {
    const { fields, appPath } = this.props;
    const { create } = this.props;
    e.preventDefault();
    const values = fields.$values();

    values.promotedMax *= 1;
    const rs = await create(values);

    if (rs && rs.status === 200) {
      fields.$reset();
      this.redirect(`${appPath}/admins`);
    }
  }

  async update(e) {
    const { fields, params } = this.props;
    const { update, get, clearForm } = this.props;
    e.preventDefault();
    const values = fields.$valuesChanged();

    if (Object.keys(values).length > 0) {
      values.uid = params.uid;

      const rs = await update(values);

      if (rs && (rs.status === 200 || rs.status === 204)) {
        await get({ uid: params.uid });
        fields.$reset();
      }
    }
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  render() {
    const { apiHost, fields, form, editForm, obj } = this.props;

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;
    return (
      <BootstrapForm onSubmit={editForm ? this.update : this.create} noValidate>
        <Container>
          <Row>
            <Col xs="6">
              {!editForm && (
                <Input
                  field="email"
                  title="Email"
                  type="text"
                  loading={form.get("loading")}
                  error={form.get("error")}
                  clearError={this.clearError.bind(this, "email")}
                  autoFocus
                  {...fields.email}
                />
              )}
            </Col>
            <Col xs="6">
              {!editForm && (
                <Input
                  field="password"
                  title="Hasło"
                  type="password"
                  loading={form.get("loading")}
                  error={form.get("error")}
                  clearError={this.clearError.bind(this, "password")}
                  {...fields.password}
                />
              )}
            </Col>
            <ButtonWithLoader
              className="button-loader"
              size="lg"
              color={dirty ? "warning" : "success"}
              text={editForm ? "Zapisano" : "Wprowadź dane"}
              isLoading={form.get("loading")}
              loadingText={"Zapisuję zmiany..."}
              isDirty={dirty}
              dirtyText={editForm ? "Zapisz zmiany" : "Dodaj administratora"}
            />
          </Row>
        </Container>
      </BootstrapForm>
    );
  }
}

Form.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Form = fields(Form, {
  path: "adminForm",
  fields: formFields,
  getInitialState: ({ obj, editForm }) => {
    return {
      email: editForm ? obj.get("email") : "",
      password: editForm ? obj.get("password") : ""
    };
  }
});

Form = connect(
  state => ({
    apiHost: state.config.apiHost,
    form: state.admin.form,
    fields: state.fields,
    appPath: state.config.appPath
  }),
  { create, clearError, clearForm, get, update }
)(Form);

export { Form, formFields };



// WEBPACK FOOTER //
// ./src/browser/admin/Form.js